export enum QuarantineItemTypes {
  ITEM_TYPE_ATTACHMENT = 0,
  ITEM_TYPE_EMAIL = 1,
}

export function convertIntToItemType(value: number) {
  switch (value) {
    case QuarantineItemTypes.ITEM_TYPE_ATTACHMENT:
      return 'Attachment';
    case QuarantineItemTypes.ITEM_TYPE_EMAIL:
      return 'Email';
    default:
      return '';
  }
}
